module.exports = __webpack_public_path__ + "img/12.2dde75e9.jpg";